module.exports = __webpack_public_path__ + "5df9e9ed4b97c81c34112617d37cebe0.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/imagenes biofar.png
// module id = 604
// module chunks = 0